import api from "./api";

const inFlightTicketQueries = new Map();

const buildQueryKey = params =>
  JSON.stringify(
    Object.keys(params || {})
      .sort()
      .reduce((normalized, key) => {
        if (params[key] !== undefined) {
          normalized[key] = params[key];
        }
        return normalized;
      }, {})
  );

export const getTickets = params => {
  const queryKey = buildQueryKey(params);
  const existingRequest = inFlightTicketQueries.get(queryKey);

  if (existingRequest) {
    return existingRequest;
  }

  const request = api
    .get("/tickets", { params })
    .finally(() => {
      if (inFlightTicketQueries.get(queryKey) === request) {
        inFlightTicketQueries.delete(queryKey);
      }
    });

  inFlightTicketQueries.set(queryKey, request);
  return request;
};
